<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 bg-gray-300  border-b shadow-sm pt-1 px-5">
        <div class="my-3 d-flex">
          <textarea class="form-control border-0 bg-light me-2" rows="1"
                    v-model="message"
                    placeholder="Enter Message And Hit Enter!">
          </textarea>
          <button @click="sendMessage"
              :class="['btn btn-primary', message.length < 1 ? 'disabled':'', 'h-25']">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M21.4274 2.5783C20.9274 2.0673 20.1874 1.8783 19.4974 2.0783L3.40742 6.7273C2.67942 6.9293 2.16342 7.5063 2.02442 8.2383C1.88242 8.9843 2.37842 9.9323 3.02642 10.3283L8.05742 13.4003C8.57342 13.7163 9.23942 13.6373 9.66642 13.2093L15.4274 7.4483C15.7174 7.1473 16.1974 7.1473 16.4874 7.4483C16.7774 7.7373 16.7774 8.2083 16.4874 8.5083L10.7164 14.2693C10.2884 14.6973 10.2084 15.3613 10.5234 15.8783L13.5974 20.9283C13.9574 21.5273 14.5774 21.8683 15.2574 21.8683C15.3374 21.8683 15.4274 21.8683 15.5074 21.8573C16.2874 21.7583 16.9074 21.2273 17.1374 20.4773L21.9074 4.5083C22.1174 3.8283 21.9274 3.0883 21.4274 2.5783Z" fill="#ffffff"></path>
              <path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" d="M3.01049 16.8078C2.81849 16.8078 2.62649 16.7348 2.48049 16.5878C2.18749 16.2948 2.18749 15.8208 2.48049 15.5278L3.84549 14.1618C4.13849 13.8698 4.61349 13.8698 4.90649 14.1618C5.19849 14.4548 5.19849 14.9298 4.90649 15.2228L3.54049 16.5878C3.39449 16.7348 3.20249 16.8078 3.01049 16.8078ZM6.77169 18.0002C6.57969 18.0002 6.38769 17.9272 6.24169 17.7802C5.94869 17.4872 5.94869 17.0132 6.24169 16.7202L7.60669 15.3542C7.89969 15.0622 8.37469 15.0622 8.66769 15.3542C8.95969 15.6472 8.95969 16.1222 8.66769 16.4152L7.30169 17.7802C7.15569 17.9272 6.96369 18.0002 6.77169 18.0002ZM7.02539 21.5682C7.17139 21.7152 7.36339 21.7882 7.55539 21.7882C7.74739 21.7882 7.93939 21.7152 8.08539 21.5682L9.45139 20.2032C9.74339 19.9102 9.74339 19.4352 9.45139 19.1422C9.15839 18.8502 8.68339 18.8502 8.39039 19.1422L7.02539 20.5082C6.73239 20.8012 6.73239 21.2752 7.02539 21.5682Z" fill="#ffffff"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from "vue";
import getUser from "@/composables/getUser";
import {timeStamp} from "@/firebase/config";
import useCollection from "@/composables/useCollection";

export default {
  name: "ChatForm",
  setup(){
    let message = ref("");
    let {user} = getUser();
    let {errorMessage, addDoc} = useCollection("messages");

    let sendMessage = async()=>{
      let chat={
        message: message.value,
        name: user.value.displayName,
        userId: user.value.uid,
        created_at: timeStamp(),
      }
      console.log(chat);
      let res =await addDoc(chat);
      res? console.log("success"): console.log("error");
      message.value="";
    }

    return {message, sendMessage}
  }
}
</script>

<style scoped>
.border-b{
  border-radius: 0 0 10px 10px;
}
.bg-gray-300{
  background: #cbd5e1;
}
</style>